import type { PayoutBatchesTranslations } from "../interfaces/payoutBatches";

export const payoutBatchesTranslations: PayoutBatchesTranslations = {
  // Page
  page_title: "Pagamentos em lote",
  page_subtitle: "Envie uma planilha com muitos pagamentos, revise e execute como uma única operação.",
  action_new_batch: "Novo lote",
  action_refresh: "Atualizar",
  action_back_to_list: "Voltar aos lotes",
  action_view_file: "Ver arquivo original",
  action_download_report: "Baixar relatório",
  action_history: "Histórico",
  action_cancel_batch: "Cancelar lote",
  action_revalidate: "Revalidar",
  action_retry_failed: "Tentar novamente {{count}} falhas",
  action_retry_failed_one: "Tentar novamente 1 falha",
  action_retry_failed_other: "Tentar novamente {{count}} falhas",
  action_resume: "Retomar",
  action_upload_another: "Enviar outro arquivo",
  action_validate_again: "Validar novamente",
  action_close: "Fechar",
  action_cancel: "Cancelar",
  error_load: "Não conseguimos carregar o lote.",
  error_retry: "Tentar novamente",
  error_generic: "Algo deu errado. Tente novamente.",
  error_network: "Sem conexão. Verifique sua rede e tente novamente.",
  not_found_title: "Lote não encontrado",
  not_found_description: "O link aponta para um lote que não existe ou que não pertence à sua organização.",

  // List
  org_picker_label: "Organização",
  org_picker_placeholder: "Busque por nome, e-mail ou id",
  org_picker_loading: "Carregando organizações…",
  org_picker_empty: "Sem resultados",
  org_picker_searching: "Buscando…",
  org_picker_search_error: "A busca falhou. Tente novamente.",
  org_picker_catalog_error: "Não conseguimos carregar as organizações.",
  org_picker_catalog_truncated: "O catálogo está limitado: busque por nome para chegar a todas.",
  org_picker_global_option: "Todas as organizações",
  org_picker_global_hint: "Mostrando os lotes de todas as organizações.",
  org_picker_org_hint: "Mostrando apenas os lotes desta organização.",
  org_picker_required_hint: "Escolha a organização à qual o lote pertence.",
  list_filter_corridor_label: "Corredor",
  list_filter_corridor_all: "Todos os corredores",
  list_filter_status_label: "Status",
  list_filter_status_all: "Todos os status",
  kpi_all: "Todos",
  kpi_pending_review: "Em revisão",
  kpi_pending_approval: "Para aprovar",
  kpi_executing: "Executando",
  kpi_completed: "Concluídos",
  kpi_with_errors: "Com erros",
  kpi_closed: "Encerrados",
  list_col_created: "Data",
  list_col_organization: "Organização",
  list_col_corridor: "Corredor",
  list_col_rows: "Pagamentos",
  list_col_debit: "Débito",
  list_col_status: "Status",
  list_col_file: "Arquivo",
  list_rows_progress: "{{selected}} de {{total}}",
  list_expires_in: "Expira em {{time}}",
  list_empty_title: "Envie seu primeiro lote",
  list_empty_description: "Baixe o modelo do corredor, preencha um pagamento por linha e envie aqui.",
  list_empty_filtered_title: "Nenhum lote corresponde",
  list_empty_filtered_description: "Altere os filtros para ver outros lotes.",
  list_live_updated_at: "Atualizado {{time}}",

  // Setup (create)
  setup_title: "Novo lote de pagamentos",
  setup_subtitle: "Escolha de onde sai o dinheiro e para qual rede vai; depois envie o modelo preenchido.",
  step_configure: "Configurar",
  step_review: "Revisar",
  step_approval: "Aprovação",
  step_confirm: "Pagamento",
  setup_organization_label: "Organização",
  setup_org_not_enabled_title: "Esta organização não vê pagamentos em lote",
  setup_org_not_enabled_text:
    "Seus membros não têm o módulo habilitado: outro usuário da equipe Coloca terá que aprovar o lote. Você pode habilitá-lo em Organizações.",
  setup_wallet_label: "Carteira de origem",
  setup_wallet_placeholder: "Escolha a carteira a debitar",
  setup_wallet_loading: "Carregando carteiras…",
  setup_wallet_empty: "Esta organização não tem carteiras ativas.",
  setup_wallet_frozen: "congelada",
  setup_wallet_option: "{{currency}} · disponível {{amount}}",
  setup_corridor_label: "Corredor de destino",
  setup_corridor_description: "Um lote paga por uma única rede. O modelo muda conforme a rede escolhida.",
  setup_corridor_unavailable: "Indisponível no momento",
  setup_corridor_delivers: "Entrega em {{currency}}",
  setup_concept_label: "Descrição",
  setup_concept_description: "Usada nas linhas que deixarem a descrição vazia.",
  setup_concept_placeholder: "Folha de setembro",
  setup_cross_currency_title: "Conversão incluída",
  setup_cross_currency_text:
    "Sua carteira em {{source}} é convertida para {{currency}} dentro de cada pagamento. Na validação você verá uma taxa indicativa; a taxa final é fixada ao executar, dentro da tolerância configurada.",
  setup_submit: "Enviar e validar",
  setup_submitting: "Enviando…",
  setup_two_factor_required: "Ative a autenticação em duas etapas para enviar lotes de pagamentos.",
  setup_upload_error_title: "Não conseguimos aceitar o arquivo",
  setup_upload_archive_failed: "Não conseguimos guardar o arquivo. Tente novamente em instantes.",
  template_title: "Modelo {{rail}}",
  template_description:
    "Um pagamento por linha. O valor é o que o beneficiário recebe; as taxas são calculadas por cima.",
  template_download: "Baixar modelo",
  template_downloading: "Baixando…",
  template_need_corridor: "Escolha o corredor para baixar o modelo.",
  template_error: "Não conseguimos baixar o modelo.",
  dropzone_instruction: "Clique para enviar o lote ou arraste-o aqui",
  dropzone_instruction_drop: "Solte o arquivo aqui",
  dropzone_helper: "Use o modelo do corredor: um pagamento por linha.",
  dropzone_constraints: "Máximo {{max}} MB · .xlsx ou .csv",
  dropzone_change: "Trocar",
  dropzone_remove: "Remover",
  dropzone_file_size: "{{size}} KB",
  file_error_too_large: "O arquivo tem {{size}} MB; o máximo é {{max}} MB.",
  file_error_unsupported_type: "Aceitamos apenas .xlsx ou .csv.",
  file_error_required: "Envie o arquivo do lote.",

  // Statuses
  status_batch_uploaded: "Enviado",
  status_batch_validating: "Validando",
  status_batch_validation_failed: "Validação falhou",
  status_batch_ready: "Em revisão",
  status_batch_pending_approval: "Aguardando aprovação",
  status_batch_approved: "Aprovado",
  status_batch_executing: "Executando",
  status_batch_completed: "Concluído",
  status_batch_completed_with_errors: "Concluído com erros",
  status_batch_failed: "Falhou",
  status_batch_cancelled: "Cancelado",
  status_batch_expired: "Expirado",
  status_item_pending: "Pendente",
  status_item_invalid: "Com erros",
  status_item_excluded: "Excluída",
  status_item_selected: "Selecionada",
  status_item_queued: "Na fila",
  status_item_processing: "Processando",
  status_item_submitted: "Enviada",
  status_item_paid: "Paga",
  status_item_failed: "Falhou",
  status_item_reversed: "Revertida",
  status_item_cancelled: "Cancelada",

  // Detail
  detail_created_at: "Criado",
  detail_created_by: "Criado por",
  detail_corridor: "Corredor",
  detail_file: "Arquivo",
  detail_rows: "{{count}} linhas",
  detail_rows_one: "1 linha",
  detail_rows_other: "{{count}} linhas",
  detail_updated_at: "Atualizado {{time}}",
  detail_live: "ao vivo",
  detail_polling: "a cada {{seconds}} s",
  validating_title: "Validando {{count}} linhas…",
  validating_description:
    "Verificamos cada destino, valor e limite, procuramos duplicados e calculamos o custo. Esta tela se atualiza sozinha.",
  validation_failed_title: "Não conseguimos validar o lote",
  validation_failed_description: "Corrija o arquivo e envie novamente, ou cancele este lote.",
  validation_failed_description_revalidate:
    "Corrija o arquivo e envie novamente, ou cancele este lote. Se a causa já foi resolvida fora do arquivo (por exemplo, a verificação da organização), valide-o novamente.",
  expiry_banner: "Este lote expira em {{time}}. Depois será preciso enviá-lo novamente.",
  expiry_expired: "O lote expirou antes de ser confirmado.",
  warning_same_file_link: "Ver o lote anterior",
  warning_fees_updated_title: "As comissões mudaram desde a última validação",
  warning_fees_updated_text:
    "Recalculamos os preços do lote com a tarifa vigente. Revise o novo débito antes de confirmar.",
  warning_fees_updated_fees: "Comissões",
  warning_fees_updated_debit: "Débito total",
  warning_fees_updated_before: "Antes",
  warning_fees_updated_after: "Agora",
  cancel_title: "Cancelar o lote",
  cancel_description: "Nenhuma linha será paga. Você pode enviar o arquivo novamente quando quiser.",
  cancel_reason_label: "Motivo",
  cancel_reason_placeholder: "Opcional: por que está sendo cancelado",
  cancel_confirm: "Cancelar lote",
  cancel_success: "Lote cancelado.",
  events_title: "Histórico do lote",
  events_description: "Cada ação e cada mudança de status, com quem a fez.",
  events_empty: "Ainda não há eventos.",
  events_error: "Não conseguimos carregar o histórico.",
  events_load_more: "Carregar mais",
  event_meta_code: "Código",
  event_meta_run: "Execução {{run}}",
  event_meta_rows: "{{count}} linhas",
  event_meta_reason: "Motivo",
  event_reason_fees_changed: "as comissões mudaram",
  event_type_batch_uploaded: "Lote enviado",
  event_type_file_archived: "Arquivo arquivado",
  event_type_validation_started: "Validação iniciada",
  event_type_validation_finished: "Validação concluída",
  event_type_validation_failed: "Validação falhou",
  event_type_item_excluded: "Linha excluída",
  event_type_item_included: "Linha incluída",
  event_type_selection_changed: "Seleção alterada",
  event_type_revalidation_requested: "Revalidação solicitada",
  event_type_submitted_for_approval: "Enviado para aprovação",
  event_type_approval_rejected: "Devolvido pelo aprovador",
  event_type_submission_withdrawn: "Retirado da aprovação",
  event_type_approved: "Lote aprovado",
  event_type_provider_balance_acknowledged: "Liquidez do corredor reconhecida",
  event_type_execution_enqueued: "Execução enfileirada",
  event_type_execution_enqueue_failed: "Não foi possível enfileirar a execução",
  event_type_execution_started: "Execução iniciada",
  event_type_item_processing: "Linha em processamento",
  event_type_item_submitted: "Linha enviada",
  event_type_item_paid: "Linha paga",
  event_type_item_failed: "Linha falhou",
  event_type_item_reversed: "Linha revertida",
  event_type_item_status_synced: "Status da linha atualizado pela rede",
  event_type_batch_halted: "Lote interrompido",
  event_type_execution_finished: "Execução concluída",
  event_type_execution_failed: "Execução falhou",
  event_type_retry_requested: "Nova tentativa solicitada",
  event_type_run_resumed: "Execução retomada",
  event_type_cancelled: "Lote cancelado",
  event_type_expired: "Lote expirado",
  event_type_stall_resumed: "Execução retomada após uma pausa",
  event_type_alert_sent: "Alerta enviado",
  actor_system: "Sistema",
  actor_provider: "Rede de pagamento",
  actor_coloca_team: "Equipe Coloca",
  actor_you: "Você",
  actor_member: "Usuário",

  // Review
  review_title: "Revise o lote",
  review_subtitle: "Confirme quais linhas serão pagas e quanto será debitado antes de continuar.",
  balance_title: "Saldo da carteira",
  balance_available: "Disponível",
  balance_debit: "Débito do lote",
  balance_remaining: "Restaria",
  balance_sufficient: "Suficiente para pagar as linhas selecionadas",
  balance_insufficient: "Insuficiente para as linhas selecionadas",
  balance_unknown: "Não conseguimos ler o saldo",
  balance_frozen: "A carteira está congelada: não é possível executar pagamentos",
  liquidity_title: "Liquidez do corredor {{corridor}}",
  liquidity_ok: "Suficiente",
  liquidity_insufficient: "Insuficiente",
  liquidity_stale: "Desatualizada",
  liquidity_unavailable: "Indisponível",
  liquidity_unsupported: "Sem leitura para esta rede",
  liquidity_available: "Disponível {{amount}}",
  totals_title: "Este lote",
  totals_payments: "{{count}} pagamentos",
  totals_payments_one: "1 pagamento",
  totals_payments_other: "{{count}} pagamentos",
  totals_receive: "Os beneficiários recebem",
  totals_fees: "Taxas",
  totals_debit: "Débito indicativo",
  totals_rate: "Taxa indicativa",
  totals_priced_at: "Cotado {{time}}",
  totals_fx_notice: "A taxa final é fixada ao executar cada pagamento, dentro da tolerância configurada.",
  suggestions_title: "O saldo não é suficiente",
  suggestions_description:
    "Escolha uma forma de ajustar a seleção ao saldo disponível, ou recarregue a carteira.",
  suggestion_keep_file_order: "Respeitar a ordem do arquivo",
  suggestion_smallest_first: "Pagar o maior número de linhas",
  suggestion_largest_first: "Pagar o maior valor",
  suggestion_meta: "{{count}} pagamentos · débito {{debit}} · restam {{remaining}}",
  suggestion_apply: "Aplicar",
  items_filter_all: "Todas",
  items_filter_selected: "Selecionadas",
  items_filter_errors: "Com erros",
  items_filter_warnings: "Com avisos",
  items_filter_excluded: "Excluídas",
  items_filter_processing: "Processando",
  items_filter_submitted: "Enviadas",
  items_filter_paid: "Pagas",
  items_filter_failed: "Falharam",
  items_filter_reversed: "Revertidas",
  items_select_all_valid: "Selecionar válidas",
  items_deselect_all: "Limpar seleção",
  items_exclude_with_warnings: "Excluir com avisos",
  items_select_page: "Selecionar as linhas desta página",
  items_select_row: "Selecionar a linha {{row}}",
  items_col_row: "#",
  items_col_beneficiary: "Beneficiário",
  items_col_receive: "Recebe",
  items_col_fee: "Taxa",
  items_col_debit: "Débito",
  items_col_rate: "Câmbio",
  items_col_status: "Status",
  items_col_issues: "Ocorrências",
  items_col_reason: "Motivo",
  items_col_payout: "Pagamento",
  items_empty_title: "Nenhuma linha corresponde",
  items_empty_description: "Altere o filtro para ver outras linhas do lote.",
  items_syncing: "Salvando a seleção…",
  items_errors_count: "{{count}} erros",
  items_errors_count_one: "1 erro",
  items_errors_count_other: "{{count}} erros",
  items_warnings_count: "{{count}} avisos",
  items_warnings_count_one: "1 aviso",
  items_warnings_count_other: "{{count}} avisos",
  row_drawer_title: "Linha {{row}}",
  row_errors_title: "Erros",
  row_warnings_title: "Avisos",
  row_pricing_title: "Custo do pagamento",
  row_raw_title: "Dados do arquivo",
  row_destination_title: "Destino",
  row_payout_link: "Ver o pagamento",
  row_batch_link: "Ver o outro lote",
  row_no_pricing: "Sem custo calculado",
  row_attempt: "Tentativa {{attempt}}",
  row_beneficiary_unknown: "Sem nome",
  destination_label_pix: "Chave PIX ({{type}})",
  destination_label_spei: "CLABE",
  destination_label_cbu_cvu: "{{type}}",
  destination_label_breb: "Chave Bre-B ({{type}})",
  destination_label_transfiya: "Conta {{type}}",
  destination_label_pse: "Conta {{type}}",
  destination_label_usdt: "Endereço {{type}}",
  destination_label_unknown: "Destino",
  footer_summary: "{{count}} pagamentos · débito {{debit}}",
  footer_submit: "Enviar para aprovação",
  footer_submit_hint: "Outro usuário com permissão de aprovação vai revisá-lo e pagá-lo.",
  footer_blocked_no_write: "Somente leitura: você não tem permissão para preparar lotes.",
  approval_footer_approver_hint: "Confira as linhas e o débito. Ao aprovar, é paga exatamente esta seleção.",
  approval_footer_maker_hint: "Aguardando outro usuário com permissão de aprovação aprová-lo.",
  approval_footer_reader_hint: "Aguardando aprovação.",
  action_approve: "Aprovar e pagar",
  action_reject: "Devolver",
  action_withdraw: "Retirar para editar",
  submit_title: "Enviar para aprovação",
  submit_description:
    "Outra pessoa com permissão de aprovação vai revisar este lote e pagá-lo com seu código de verificação.",
  submit_rows_label: "Pagamentos",
  submit_debit_label: "Débito estimado",
  submit_frozen_note:
    "Enquanto aguarda, a seleção fica congelada. Para alterá-la, retire-o da aprovação. O lote continua vencendo no mesmo horário.",
  submit_confirm: "Enviar para aprovação",
  submit_success: "Lote enviado para aprovação",
  approval_banner_title: "Aguardando aprovação",
  approval_banner_text_self:
    "Você o enviou em {{when}}. A seleção fica congelada até outro usuário aprová-lo ou devolvê-lo.",
  approval_banner_text_other:
    "Enviado para aprovação em {{when}}. A seleção fica congelada até ser aprovada ou devolvida.",
  returned_banner_title: "O aprovador devolveu este lote ({{when}})",
  returned_banner_text: "Ajuste a seleção se necessário e envie-o novamente para aprovação.",
  reject_title: "Devolver o lote",
  reject_description:
    "Nada é pago. O lote volta para revisão com a mesma seleção e quem o enviou verá seu motivo.",
  reject_reason_label: "Motivo",
  reject_reason_placeholder: "Ex.: a linha 12 paga para a conta errada",
  reject_reason_hint: "Mínimo de {{count}} caracteres.",
  reject_confirm: "Devolver",
  reject_success: "Lote devolvido para revisão",
  withdraw_title: "Retirar da aprovação?",
  withdraw_description:
    "O lote volta para revisão com a mesma seleção para que você possa editá-lo. Será preciso enviá-lo novamente.",
  withdraw_confirm: "Retirar",
  withdraw_success: "Lote retirado da aprovação",
  footer_blocked_insufficient: "O saldo não é suficiente para as linhas selecionadas.",
  footer_blocked_syncing: "Salvando a seleção…",
  footer_blocked_expired: "O lote expirou.",
  footer_blocked_none: "Selecione pelo menos uma linha.",
  footer_blocked_blockers: "O lote tem bloqueios que impedem a execução.",

  // Execute
  execute_title: "Confirmar o lote",
  execute_description: "Isto é o que vai acontecer quando você confirmar.",
  execute_payments: "{{count}} pagamentos",
  execute_debit: "Debitado da sua carteira",
  execute_fees: "Taxas incluídas",
  execute_receive: "Os beneficiários recebem",
  execute_fx_notice:
    "A taxa é indicativa: cada pagamento é convertido ao ser executado. Se a taxa variar mais de {{pct}}%, essa linha não é paga e fica marcada.",
  execute_fee_notice:
    "As comissões são recalculadas ao executar cada pagamento. Se o débito de uma linha subir mais de {{pct}}% em relação ao revisado, essa linha não é paga e fica marcada.",
  execute_irreversible:
    "Depois de confirmado, os pagamentos saem um a um e não podem ser interrompidos daqui.",
  execute_ack_liquidity_label: "Entendo o risco de liquidez do corredor",
  execute_ack_liquidity_description:
    "Não conseguimos confirmar que a rede tem fundos suficientes; alguns pagamentos podem ficar em espera.",
  execute_reviewed_label: "Revisei as linhas e os valores",
  execute_confirm: "Confirmar e executar",
  execute_arming: "Leia o resumo…",
  execute_sending: "Confirmando…",
  execute_conflict_title: "O lote mudou desde que você o revisou",
  execute_conflict_description:
    "Alguém alterou a seleção ou o lote já não está pronto. Revise os dados atualizados antes de confirmar.",
  execute_conflict_back: "Revisar novamente",
  execute_unconfirmed_title: "Não conseguimos confirmar o resultado",
  execute_unconfirmed_description:
    "Perdemos a conexão depois de enviar a confirmação. Estamos relendo o estado do lote.",
  execute_done_title: "Lote em execução",
  execute_done_description: "Os pagamentos começaram a sair. Você pode acompanhar o andamento nesta tela.",
  execute_busy_description: "Outro lote desta organização já está em execução com esta carteira.",
  execute_two_factor_required: "Ative a autenticação em duas etapas para executar lotes de pagamentos.",
  execute_success_toast: "Lote confirmado. Os pagamentos estão saindo.",
  error_fingerprint_mismatch: "O lote mudou desde que você o revisou. Revise novamente antes de confirmar.",
  approval_uploader_hint:
    "Quem carregou o lote ou o enviou para aprovação não pode aprovar seus pagamentos. Outro usuário com permissão de aprovação deve fazê-lo.",
  error_self_approval_forbidden:
    "Quem carregou o lote ou o enviou para aprovação não pode aprová-lo nem devolvê-lo. Outro usuário com permissão de aprovação deve fazê-lo.",
  error_not_ready: "O lote não está pronto para esta ação.",
  error_nothing_selected: "Não há linhas selecionadas.",
  error_insufficient_funds: "O saldo da carteira não cobre as linhas selecionadas.",
  error_organization_busy: "Outro lote desta organização já está em execução com esta carteira.",
  error_provider_balance_ack_required:
    "A liquidez do corredor não pôde ser confirmada; reconheça o risco para continuar.",
  error_expired: "O lote expirou antes de ser confirmado. Envie-o novamente.",
  error_retry_debit_exceeded:
    "As linhas repetidas custam mais do que o valor aprovado. Revise os novos preços.",
  error_items_not_retryable: "Só é possível repetir linhas que falharam sem um pagamento em andamento.",
  error_invalid_status: "Esta ação não é permitida no status atual do lote.",
  error_wallet_frozen: "A carteira de origem está congelada.",
  error_rail_disabled: "Esta rede está desativada no momento.",
  error_verification_required: "Sua organização precisa concluir a verificação antes de enviar pagamentos.",
  error_fees_changed:
    "As comissões mudaram enquanto você revisava o lote. Revise-o novamente para ver os preços atualizados.",
  error_not_pending_approval: "O lote não está mais aguardando aprovação. Recarregue para ver seu status.",
  error_not_enabled: "Os pagamentos em lote não estão habilitados para sua organização.",

  // Progress
  progress_title: "Andamento do lote",
  progress_legend_paid: "Pagas",
  progress_legend_failed: "Falharam",
  progress_legend_submitted: "Enviadas, aguardando liquidação",
  progress_legend_processing: "Processando",
  progress_legend_pending: "Pendentes",
  progress_processed: "{{done}} de {{total}} processadas",
  counters_pending: "Pendentes",
  counters_processing: "Processando",
  counters_submitted: "Enviadas",
  counters_paid: "Pagas",
  counters_failed: "Falharam",
  counters_reversed: "Revertidas",
  result_completed_title: "Lote concluído",
  result_completed_description: "Todas as linhas selecionadas foram pagas.",
  result_completed_with_errors_title: "Lote concluído com erros",
  result_completed_with_errors_description:
    "Algumas linhas não foram pagas. Verifique o motivo de cada uma e repita as que couberem.",
  result_failed_title: "A execução falhou",
  result_failed_description:
    "Um erro do sistema interrompeu o lote. As linhas já pagas não se repetem; você pode retomar as pendentes.",
  result_cancelled_title: "Lote cancelado",
  result_cancelled_description: "Nenhuma linha foi paga.",
  result_expired_title: "Lote expirado",
  result_expired_description: "O lote não foi confirmado a tempo. Envie-o novamente se ainda for válido.",
  result_halted: "O lote parou por falhas repetidas: {{reason}}.",
  result_executing_title: "Pagamentos em andamento",
  result_executing_description: "As linhas são pagas uma a uma. Você pode sair desta tela e voltar depois.",
  retry_title: "Repetir linhas que falharam",
  retry_description: "Revise o custo atualizado de cada linha antes de aprovar a nova tentativa.",
  retry_preview_loading: "Calculando os novos preços…",
  retry_preview_error: "Não conseguimos calcular os novos preços.",
  retry_col_row: "Linha",
  retry_col_new_debit: "Novo débito",
  retry_col_issue: "Ocorrência",
  retry_total: "Débito total {{amount}}",
  retry_retryable_count: "{{count}} linhas podem ser repetidas",
  retry_retryable_count_one: "1 linha pode ser repetida",
  retry_retryable_count_other: "{{count}} linhas podem ser repetidas",
  retry_none_retryable: "Nenhuma destas linhas pode ser repetida agora.",
  retry_reviewed_label: "Revisei os novos preços",
  retry_confirm: "Aprovar nova tentativa",
  retry_arming: "Leia o resumo…",
  retry_debit_changed: "Os preços mudaram de novo. Revise o total atualizado.",
  retry_two_factor_required: "Ative a autenticação em duas etapas para repetir pagamentos.",
  retry_success_toast: "Nova tentativa aprovada. As linhas voltaram à fila.",
  resume_title: "Retomar a execução",
  resume_description:
    "As linhas que não chegaram a ser processadas voltam à fila. As já pagas não se repetem.",
  resume_rows: "{{count}} linhas pendentes",
  resume_rows_one: "1 linha pendente",
  resume_rows_other: "{{count}} linhas pendentes",
  resume_reviewed_label: "Entendo quais linhas serão processadas",
  resume_confirm: "Retomar",
  resume_arming: "Leia o resumo…",
  resume_two_factor_required: "Ative a autenticação em duas etapas para retomar lotes.",
  resume_success_toast: "Execução retomada.",
  report_downloading: "Preparando o relatório…",
  report_error: "Não conseguimos baixar o relatório.",
};
